import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import translations from './translations';

const LanguageContext = createContext();

const detectLanguage = () => {
  const saved = localStorage.getItem('separatus_lang');
  if (saved && translations[saved]) return saved;

  const browserLang = navigator.language || navigator.userLanguage || '';
  if (browserLang.startsWith('de')) return 'de';
  return 'en';
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectLanguage);

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    localStorage.setItem('separatus_lang', newLang);
  }, []);

  const t = useCallback((key, vars = {}) => {
    let text = translations[lang]?.[key] || translations['de']?.[key] || key;
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replaceAll(`{${k}}`, v);
    });
    return text;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
